import isNil from 'lodash/isNil'

const endSubscriptionGoalForm = {
    bindings: {
        contract: '<',
        onStateEnd: '&',
    },
    template: require('./endSubscriptionGoalForm.jade')(),
    /** @ngInject */ controller(Contract, ApiService, ErrorCatcher) {
        const ctrl = this
        ctrl.form = {
            refGoal: null,
        }

        ctrl.isFormValid = () => !isNil(ctrl.form.refGoal)

        ctrl.submitForm = () =>
      Contract.refGoal({ id: ctrl.contract.id }, { id_ref_goal: ctrl.form.refGoal }).$promise
        .then((result) => {
            ApiService.resetPromise('userInfo')
            ctrl.onStateEnd()
        })
        .catch((error) => {
            console.error('Cannot submit refgoal', error)
            ErrorCatcher.catchError(error)
        })


        ctrl.$onInit = () => {
            ctrl.form.refGoal = ctrl.contract.id_ref_goal
        }
    },
}

export default endSubscriptionGoalForm



// WEBPACK FOOTER //
// ./src/states/endSubscription/component/endSubscriptionGoalForm.js